module.exports = __webpack_public_path__ + "static/img/binding_over.c36beeaf.png";